const typeDefault = (type) => {
    switch (type) {
        case 'boolean':
            return false;
        case 'string':
            return '';
        case 'number':
            return NaN;
        default:
            return '';
    }
};
const defaultTypeValue = (type) => {
    switch (type) {
        case 'string':
            return '';
        case 'number':
            return NaN;
        case 'boolean':
            return false;
        case 'markdown':
            return '';
        case 'select_multi':
            return [];
        default:
            return '';
    }
};
const toFormrValue = (data, def) => {
    const valuesFromDef = [];
    def.fields.forEach((field) => {
        const value = field.key.split('.').reduce((obj, key) => obj?.[key], data);
        const finalValue = field.getter ? field.getter(value) : value;
        if (!field.hidden(finalValue)) {
            valuesFromDef.push({
                value: finalValue ?? defaultTypeValue(field.type),
                ...field,
                parentData: field.needsParentData
                    ? data
                    : undefined
            });
        }
    });
    return valuesFromDef.sort((a, b) => a.order - b.order);
};
// Deep clone utility
const clone = (obj) => structuredClone(obj);
/**
 * True when `a` and `b` DIFFER — this is a "has changed" predicate, not an
 * equality check. Every caller uses it that way (dirty tracking behind the
 * admin save buttons), so inverting it would report "no unsaved changes" for a
 * form that has them and let the user navigate away losing their edits.
 *
 * Compares by JSON, so it only sees JSON-representable state and depends on
 * key order — fine for the plain form documents it is used on.
 */
const diffInObjects = (a, b) => {
    return JSON.stringify(a) !== JSON.stringify(b);
};
// Lodash-style get for nested paths
const getNestedValue = (obj, path) => path.split('.').reduce((o, key) => o?.[key], obj);
// Lodash-style set for nested paths
const setNestedValue = (obj, path, value) => {
    if (Object(obj) !== obj)
        return obj;
    if (!Array.isArray(path))
        path = path.toString().match(/[^.[\]]+/g) || [];
    path.slice(0, -1).reduce((a, c, i) => Object(a[c]) === a[c]
        ? a[c]
        : (a[c] =
            Math.abs(path[i + 1]) >> 0 === +path[i + 1]
                ? []
                : {}), obj)[path[path.length - 1]] = value;
    return obj;
};
// Reorder utilities for FormrList
const moveItemUp = (items, index, orderField) => {
    if (index <= 0)
        return null;
    const newItems = [...items];
    const temp = newItems[index];
    newItems[index] = newItems[index - 1];
    newItems[index - 1] = temp;
    return newItems.map((item, i) => ({ ...item, [orderField]: i }));
};
const moveItemDown = (items, index, orderField) => {
    if (index >= items.length - 1)
        return null;
    const newItems = [...items];
    const temp = newItems[index];
    newItems[index] = newItems[index + 1];
    newItems[index + 1] = temp;
    return newItems.map((item, i) => ({ ...item, [orderField]: i }));
};
export { typeDefault, toFormrValue, defaultTypeValue, clone, diffInObjects, getNestedValue, setNestedValue, moveItemUp, moveItemDown };
//# sourceMappingURL=formr.utils.js.map